export default n =>
  Array(n)
    .join('.')
    .split('.');
